import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => {
    return {
        heading: {
            color: theme.palette.text.disabled,
            justifyContent: "center",
            alignItems: "center",
            margin: theme.spacing(3),
            "& svg":{
                width: 48,
                height: 48,
                marginRight: theme.spacing(2)
            }
        },
        privacyLink: {
            textTransform: "none",
            fontWeight: "normal",
            fontSize: "1em",
            marginTop: theme.spacing(10)
        }
    }
})
